/**
 * 플레이어 원거리 스킬·기본 공격 투사체.
 * 발판과 충돌하지 않는다(원작처럼 전방으로 날아간다). 몬스터 1회 명중 또는 수명/맵 밖으로 사라진다.
 */

import Phaser from 'phaser';
import type { SkillDef } from '../data/balance';
import { DEPTH } from '../game/depth';

export class PlayerShot extends Phaser.Physics.Arcade.Sprite {
  readonly skill: SkillDef;
  readonly dir: 1 | -1;
  readonly speed: number;
  private life = 1800;
  private hitsLeft = 1;

  constructor(scene: Phaser.Scene, x: number, y: number, dir: 1 | -1, skill: SkillDef) {
    const tex = skill.projectile?.texture ?? 'fx-bolt';
    super(scene, x, y, tex, 0);
    this.skill = skill;
    this.dir = dir;
    this.speed = skill.projectile?.speed ?? 400;
    scene.add.existing(this);
    scene.physics.add.existing(this);
    this.setDepth(DEPTH.effect).setFlipX(dir < 0).setScale(2);
    this.arm();
    const anim = skill.projectile?.anim;
    if (anim && this.anims.exists(anim)) this.play(anim, true);
  }

  /** 물리 그룹에 넣은 뒤에도 중력·속도가 유지되게 다시 건다. */
  arm(): void {
    const body = this.body as Phaser.Physics.Arcade.Body | null;
    if (!body) return;
    body.setAllowGravity(false);
    body.setSize(18, 36, true);
    body.setVelocity(this.dir * this.speed, 0);
  }

  consumeHit(): boolean {
    this.hitsLeft -= 1;
    if (this.hitsLeft <= 0) {
      this.destroy();
      return true;
    }
    return false;
  }

  override preUpdate(time: number, delta: number): void {
    super.preUpdate(time, delta);
    this.life -= delta;
    const bounds = this.scene.physics.world.bounds;
    const off =
      this.x < bounds.x - 48 ||
      this.x > bounds.right + 48 ||
      this.y < bounds.y - 48 ||
      this.y > bounds.bottom + 48;
    if (this.life <= 0 || off || !this.active) this.destroy();
  }
}
